<div class="-error-container">
  <div class="row">
    <div class="col-xs-12">
      <div class="wpdh-404">
        <!-- <banner image="/assets/website-illustrations/new-icons/Select-a-folder.png"
          [reverse]="false">
        </banner> -->
        <h1 class="wpdh-404__title">403</h1>
        <h2>Permission denied</h2>
        <p>This content is unavailable due to access restrictions.</p>
        <p>Please <app-link [to]="'/account/login'">login</app-link> to view this page or <app-link [to]="'/contact/support'">contact us</app-link> for access </p>
      </div>
    </div>
  </div>
</div>
